<div class="skills-card__container" *ngIf="skillsForDisplay">
  <h4 class="skills-card__title">{{ title }}</h4>
  <p class="skills-card__skills">{{ skillsForDisplay }}</p>
</div>
